/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsUserControllerFindSavedLocationQueryResponse,
  TelegramProductsUserControllerFindSavedLocationQueryParams,
  TelegramProductsUserControllerFindSavedLocation401,
} from '../../types/TelegramProductsUserControllerFindSavedLocation.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsUserFindSavedLocation } from '../../methods/telegramProductsUserFindSavedLocation.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsUserFindSavedLocationQueryKey = (
  params: TelegramProductsUserControllerFindSavedLocationQueryParams,
) => [{ url: '/api/user/telegram/products/saved-location' }, ...(params ? [params] : [])] as const;

export type TelegramProductsUserFindSavedLocationQueryKey = ReturnType<
  typeof telegramProductsUserFindSavedLocationQueryKey
>;

export function telegramProductsUserFindSavedLocationQueryOptions(
  params: TelegramProductsUserControllerFindSavedLocationQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsUserFindSavedLocationQueryKey(params);
  return queryOptions<
    TelegramProductsUserControllerFindSavedLocationQueryResponse,
    ResponseErrorConfig<TelegramProductsUserControllerFindSavedLocation401>,
    TelegramProductsUserControllerFindSavedLocationQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsUserFindSavedLocation(params, config);
    },
  });
}

/**
 * {@link /api/user/telegram/products/saved-location}
 */
export function useTelegramProductsUserFindSavedLocation<
  TData = TelegramProductsUserControllerFindSavedLocationQueryResponse,
  TQueryData = TelegramProductsUserControllerFindSavedLocationQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsUserFindSavedLocationQueryKey,
>(
  params: TelegramProductsUserControllerFindSavedLocationQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsUserControllerFindSavedLocationQueryResponse,
        ResponseErrorConfig<TelegramProductsUserControllerFindSavedLocation401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsUserFindSavedLocationQueryKey(params);

  const query = useQuery(
    {
      ...telegramProductsUserFindSavedLocationQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramProductsUserControllerFindSavedLocation401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
